function handleCollapseButton(event, title, ...selectors) {
  const button = event.target.closest("button")

  button.classList.toggle("btn-collapse--active")

  if (button.classList.contains("btn-collapse--active")) {
    dataLayer.push({
      event: "sub_nav_menu",
      link_text: title,
      nav_type: "TopNav",
      page_location: window.location.href,
    })
  }

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains("collapse--active")) {
        element.setAttribute("aria-hidden", "true")
      } else {
        element.setAttribute("aria-hidden", "false")
      }
      element.classList.toggle("collapse--active")
    })
  })
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".menu-drawer__menu > li").forEach((li) => {
    const button = li.querySelector(".btn-collapse")
    const wrapper = li.querySelector(".menu-item-link")
    const link = li.querySelector("a.link")

    if (!wrapper) return
    if (button && link) {
      const style = window.getComputedStyle(button)
      if (
        style.opacity !== "0" &&
        style.display !== "none" &&
        style.visibility !== "hidden"
      ) {
        link.removeAttribute("href")
        link.style.pointerEvents = "none"
        link.style.cursor = "default"
      }
    }

    wrapper.addEventListener("click", function (event) {
      const isButton = button?.contains(event.target)
      const isLink = link?.contains(event.target)

      if (isButton) return
      if (button) {
        const style = window.getComputedStyle(button)
        if (
          style.opacity !== "0" &&
          style.display !== "none" &&
          style.visibility !== "hidden"
        ) {
          event.preventDefault()
          button.click()
        }
      }
    })
  })

  document.querySelectorAll(".menu-item-submenu-list").forEach((submenuLi) => {
    const button = submenuLi.querySelector(".btn-collapse")
    const header = submenuLi.querySelector(".menu-item-submenu-header")

    if (!button || !header) return

    const link = header.querySelector("a.link")
    if (link && button) {
      const style = window.getComputedStyle(button)
      if (
        style.opacity !== "0" &&
        style.display !== "none" &&
        style.visibility !== "hidden"
      ) {
        link.removeAttribute("href")
        link.style.pointerEvents = "none"
        link.style.cursor = "default"
      }
    }

    header.addEventListener("click", function (event) {
      const isButton = button.contains(event.target)
      if (!isButton) {
        button.click()
        event.stopPropagation()
      }
    })
  })

  document.querySelectorAll(".btn-collapse").forEach((btn) => {
    btn.addEventListener("click", (e) => e.stopPropagation())
  })
})
